import React from 'react';
import { CHROME_STORE_URL } from '../constants';

const BillingCancel: React.FC = () => {
  return (
    <div className="mx-auto max-w-2xl py-24 px-6 text-center">
      <h1 className="text-3xl font-bold text-gray-900">Checkout Canceled</h1>
      <p className="mt-4 text-gray-600">
        No worries—your card was not charged. When you’re ready, you can restart the checkout from the Tubly extension.
      </p>
      <a
        href={CHROME_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-10 inline-flex items-center bg-red-500 text-white font-bold py-3 px-8 rounded-lg text-lg transition-transform hover:scale-105 shadow-lg cursor-pointer"
      >
        Return to Tubly
      </a>
    </div>
  );
};

export default BillingCancel;
